<template>
  <DialogBase
    :visible.sync="visible"
    title="Tạo nhận xét ngày cho nhiều học sinh"
    size="lg"
    :confirm-loading="loading"
    confirm-text="Lưu"
    cancel-text="Đóng"
    :use-panel="true"
    panel-title="Nhận xét ngày chung"
    panel-subtitle="Nhập cùng nội dung theo danh mục cho nhiều học sinh"
    panel-icon="el-icon-date"
    @confirm="handleSave"
    @cancel="handleClose"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="formRules"
      label-position="top"
      class="sk-u-mt-12"
    >
      <!-- BỘ CHỌN HỌC SINH TÙY CHỌN LINH HOẠT -->
      <div class="selected-students-card">
        <div class="selected-students-card__header">
          <div class="selected-students-card__title">
            <i class="el-icon-user" /> Danh sách học sinh nhận xét
            <el-tag
              size="mini"
              :type="dataForm.students.length > 0 ? 'primary' : 'danger'"
              class="ml-2"
            >
              Đã chọn: {{ dataForm.students.length }} / {{ allStudents.length }} học sinh
            </el-tag>
          </div>
          <div class="selected-students-card__actions">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-check"
              @click="selectAllStudents"
            >
              Chọn tất cả
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-close"
              class="text-danger"
              @click="deselectAllStudents"
            >
              Bỏ chọn hết
            </el-button>
          </div>
        </div>

        <div class="selected-students-picker">
          <el-select
            v-model="selectedStudentIds"
            multiple
            filterable
            collapse-tags
            placeholder="Tìm kiếm và tích chọn học sinh cần nhận xét..."
            style="width: 100%"
            @change="onStudentSelectionChange"
          >
            <el-option
              v-for="student in allStudents"
              :key="student.studentId"
              :label="student.studentName"
              :value="student.studentId"
            />
          </el-select>
        </div>

        <div v-if="dataForm.students.length > 0" class="selected-students">
          <el-tag
            v-for="student in dataForm.students"
            :key="student.studentId"
            closable
            size="small"
            class="selected-student-tag"
            @close="removeStudent(student.studentId)"
          >
            {{ student.studentName }}
          </el-tag>
        </div>
        <div v-else class="selected-students-empty">
          <i class="el-icon-warning-outline" /> Chưa có học sinh nào được chọn. Vui lòng chọn học sinh ở ô trên!
        </div>
      </div>

      <div class="sk-form-grid">
        <el-form-item label="Ngày" prop="date">
          <el-date-picker
            v-model="dataForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            placeholder="Chọn ngày"
            style="width: 100%"
            :clearable="false"
            disabled
          />
        </el-form-item>
      </div>

      <div class="evl-items-section">
        <div v-for="(item, index) in dataForm.items" :key="item.categoryId" class="evl-item-card">
          <div class="evl-item-card__header">
            <span class="evl-category-name"><i class="el-icon-folder" /> {{ item.categoryName }}</span>
          </div>

          <div v-if="item._templates.length > 0" class="evl-item-templates">
            <div class="template-picker">
              <div
                v-for="template in item._templates"
                :key="template.id"
                class="template-item"
                @click="selectTemplate(index, template)"
              >
                <i class="el-icon-document" />
                <span>{{ template.content }}</span>
              </div>
            </div>
          </div>
          <div v-else-if="item._templateLoading" class="evl-item-templates">
            <span class="template-loading-hint"><i class="el-icon-loading" /> Đang tải mẫu...</span>
          </div>

          <el-input
            v-model="item.content"
            type="textarea"
            :rows="3"
            placeholder="Nhập nội dung nhận xét hoặc chọn mẫu ở trên..."
            maxlength="2000"
            show-word-limit
          />
        </div>
      </div>

      <!-- File/ảnh đính kèm (Ở DƯỚI CÙNG SAU CÁC NHẬN XÉT) -->
      <div class="evl-upload-section">
        <div class="evl-upload-section__header">
          <span class="evl-upload-title">
            <i class="el-icon-paperclip" /> File & hình ảnh đính kèm
          </span>
          <span class="evl-upload-subtitle">Tối đa 3 file/nhận xét (dùng chung cho các học sinh đã chọn)</span>
        </div>
        <el-upload
          drag
          action="#"
          :auto-upload="false"
          :file-list="fileList"
          :limit="3"
          accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
          multiple
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          :on-exceed="handleFileExceed"
          class="evl-drag-uploader"
        >
          <i class="el-icon-upload" />
          <div class="el-upload__text">
            Kéo thả file/ảnh vào đây hoặc <em>nhấn để chọn file</em>
          </div>
        </el-upload>
      </div>
    </el-form>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import EvaluationService from "@/modules/evaluation/services/EvaluationService";
import EvaluationCategoryService from "@/modules/evaluation/services/EvaluationCategoryService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import moment from "moment";
import { EVALUATION_FILE_MAX_COUNT, isEvaluationFileAllowed } from "@/modules/evaluation/utils/evaluationFile";

export default {
  name: "EvaluationDailyBatchFormDialog",
  components: { DialogBase },
  props: {
    date: { type: String, default: "" },
  },
  data() {
    return {
      visible: false,
      loading: false,
      categoryList: [],
      allStudents: [],
      selectedStudentIds: [],
      dataForm: {
        students: [],
        date: moment().format("YYYY-MM-DD"),
        items: [],
      },
      fileList: [],
      formRules: {
        date: [{ required: true, message: "Vui lòng chọn ngày", trigger: "change" }],
      },
    };
  },
  methods: {
    async openForCreate(preselectedStudents = [], allClassStudents = []) {
      this._resetForm();

      // Nạp toàn bộ học sinh lớp để người dùng có thể tự do thêm bớt
      const sourceAll = allClassStudents && allClassStudents.length > 0
        ? allClassStudents
        : preselectedStudents;

      this.allStudents = (sourceAll || []).map(student => ({
        studentId: student.studentId,
        studentName: student.studentName,
      }));

      // Nếu có học sinh được tích chọn trước từ bảng -> chỉ chọn những bạn đó
      // Nếu không có ai được tích chọn trước -> mặc định chọn tất cả để tiện nhận xét cả lớp
      const initialSelected = preselectedStudents && preselectedStudents.length > 0
        ? preselectedStudents
        : this.allStudents;

      this.selectedStudentIds = initialSelected.map(s => s.studentId);
      this._syncStudentsFromIds();

      this.dataForm.date = this.date || moment().format("YYYY-MM-DD");
      await this.fetchCategories();
      this.visible = true;
    },

    onStudentSelectionChange(ids) {
      this.selectedStudentIds = ids;
      this._syncStudentsFromIds();
    },

    _syncStudentsFromIds() {
      this.dataForm.students = this.allStudents.filter(s =>
        this.selectedStudentIds.includes(s.studentId)
      );
    },

    selectAllStudents() {
      this.selectedStudentIds = this.allStudents.map(s => s.studentId);
      this._syncStudentsFromIds();
    },

    deselectAllStudents() {
      this.selectedStudentIds = [];
      this._syncStudentsFromIds();
    },

    removeStudent(studentId) {
      this.selectedStudentIds = this.selectedStudentIds.filter(id => id !== studentId);
      this._syncStudentsFromIds();
    },

    async fetchCategories() {
      try {
        const response = await EvaluationCategoryService.getCategories();
        this.categoryList = response.data.data || [];
        this.dataForm.items = this.categoryList.map(category => ({
          categoryId: String(category.id),
          categoryName: category.name,
          content: "",
          _templates: [],
          _templateLoading: false,
        }));
        this.dataForm.items.forEach((item, index) => this.fetchTemplates(index, item.categoryId));
      } catch {
        this.categoryList = [];
        this.dataForm.items = [];
        NotifyMessage.leftCornerNotificationError("Không thể tải danh mục nhận xét!");
      }
    },

    async fetchTemplates(index, categoryId) {
      this.$set(this.dataForm.items[index], "_templateLoading", true);
      try {
        const response = await EvaluationCategoryService.getTemplates(categoryId);
        this.$set(this.dataForm.items[index], "_templates", response.data.data || []);
      } catch {
        this.$set(this.dataForm.items[index], "_templates", []);
      } finally {
        this.$set(this.dataForm.items[index], "_templateLoading", false);
      }
    },

    selectTemplate(index, template) {
      const item = this.dataForm.items[index];
      item.content = item.content && item.content.trim()
        ? `${item.content.trimEnd()}\n${template.content}`
        : template.content;
    },

    async handleSave() {
      const valid = await this.$refs.dataForm.validate().catch(() => false);
      if (!valid) return;

      if (this.dataForm.students.length === 0) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn ít nhất 1 học sinh nhận xét!");
        return;
      }

      const items = this.dataForm.items
        .filter(item => item.categoryId && typeof item.content === "string" && item.content.trim())
        .map(item => ({
          categoryId: item.categoryId,
          categoryName: item.categoryName,
          content: item.content.trim(),
        }));

      if (items.length === 0) {
        NotifyMessage.leftCornerNotificationError("Vui lòng nhập ít nhất 1 danh mục có nội dung nhận xét!");
        return;
      }

      this.loading = true;
      try {
        await EvaluationService.createDailyBatchCommon({
          date: this.dataForm.date,
          students: this.dataForm.students,
          items,
          files: this.getFiles(),
        });
        NotifyMessage.leftCornerNotificationSuccess(
          `Tạo nhận xét ngày cho ${this.dataForm.students.length} học sinh thành công!`
        );
        this.$emit("saved");
        this.handleClose();
      } catch (error) {
        NotifyMessage.leftCornerNotificationError(
          error?.response?.data?.message || "Tạo nhận xét ngày thất bại!"
        );
      } finally {
        this.loading = false;
      }
    },

    handleClose() {
      this.visible = false;
      this._resetForm();
    },

    handleFileChange(file, fileList) {
      if (!isEvaluationFileAllowed(file.name)) {
        NotifyMessage.leftCornerNotificationError("Định dạng file không được hỗ trợ!");
        const index = fileList.indexOf(file);
        if (index > -1) fileList.splice(index, 1);
        return;
      }
      this.fileList = fileList;
    },

    handleFileRemove(file, fileList) {
      this.fileList = fileList;
    },

    handleFileExceed() {
      NotifyMessage.leftCornerNotificationError(`Chỉ được đính kèm tối đa ${EVALUATION_FILE_MAX_COUNT} file!`);
    },

    getFiles() {
      return this.fileList.map(file => file.raw).filter(Boolean);
    },

    _resetForm() {
      this.dataForm = {
        students: [],
        date: moment().format("YYYY-MM-DD"),
        items: [],
      };
      this.allStudents = [];
      this.selectedStudentIds = [];
      this.fileList = [];
      this.$nextTick(() => this.$refs.dataForm?.clearValidate());
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";

.evl-items-section {
  max-height: 440px;
  overflow-y: auto;
  padding-right: 6px;
}

.evl-item-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 12px;
}

.evl-item-card__header {
  margin-bottom: 10px;
}

.selected-students-card {
  margin: 4px 0 14px;
  padding: 12px 14px;
  border: 1px solid #dbeafe;
  border-radius: 12px;
  background: #eff6ff;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  &__title {
    font-size: 13.5px;
    font-weight: 700;
    color: #1e40af;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__actions {
    display: flex;
    gap: 8px;

    .text-danger {
      color: #ef4444;
      &:hover {
        color: #dc2626;
      }
    }
  }
}

.selected-students-picker {
  margin-bottom: 10px;
}

.selected-students {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 110px;
  overflow-y: auto;
  padding: 4px 0;
}

.selected-student-tag {
  background: #ffffff;
  border-color: #bfdbfe;
  color: #1e40af;
  border-radius: 6px;
  font-weight: 500;
}

.selected-students-empty {
  font-size: 12.5px;
  color: #ef4444;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
}

.template-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.template-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  font-size: 12px;
  background: #ffffff;
  border: 1px dashed #cbd5e1;
  border-radius: 6px;
  color: #475569;
  cursor: pointer;
  max-width: 240px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    border-color: #2563eb;
    color: #2563eb;
    background: #eff6ff;
  }
}

.template-loading-hint {
  font-size: 12px;
  color: #94a3b8;
}

.evl-category-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 13.5px;
}

.evl-upload-section {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px dashed #e2e8f0;
}

.evl-upload-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.evl-upload-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #334155;
  display: flex;
  align-items: center;
  gap: 6px;

  i {
    color: #2563eb;
    font-size: 15px;
  }
}

.evl-upload-subtitle {
  font-size: 12px;
  color: #94a3b8;
}

.evl-drag-uploader {
  width: 100%;

  /deep/ .el-upload {
    width: 100%;
  }

  /deep/ .el-upload-dragger {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px dashed #cbd5e1;
    border-radius: 12px;
    background: #f8fafc;
    transition: all 0.2s ease;

    &:hover {
      border-color: #3b82f6;
      background: #eff6ff;
    }

    .el-icon-upload {
      font-size: 32px;
      color: #3b82f6;
      margin: 0 0 2px;
      line-height: 1;
    }

    .el-upload__text {
      font-size: 13px;
      color: #64748b;
      line-height: 1.4;

      em {
        color: #2563eb;
        font-weight: 600;
        font-style: normal;
      }
    }
  }

  /deep/ .el-upload-list {
    margin-top: 8px;

    .el-upload-list__item {
      border-radius: 8px;
      background: #f1f5f9;
      border: 1px solid #e2e8f0;
      margin-top: 6px;
      transition: all 0.15s ease;

      &:hover {
        background: #e2e8f0;
      }
    }
  }
}

.ml-2 {
  margin-left: 8px;
}
</style>
